var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirlHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29374",
    "data-name": "Group 29374",
    transform: "translate(-87.999 -182.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(87.999 182.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_2_",
    "data-name": "svgexport-17 (2)",
    transform: "translate(104.834 188.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49906",
    "data-name": "Path 49906",
    d: "M35.439.048a9.737,9.737,0,0,0-7.295,9.687,11.989,11.989,0,0,0,2.67,7.693,1.442,1.442,0,0,0,1.107.512h5.37V.589A2,2,0,0,0,35.439.048Z",
    transform: "translate(-27.606 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49907",
    "data-name": "Path 49907",
    d: "M250.352.048A2,2,0,0,0,248.5.589V17.94h5.37a1.442,1.442,0,0,0,1.107-.512,11.989,11.989,0,0,0,2.67-7.693A9.737,9.737,0,0,0,250.352.048Z",
    transform: "translate(-238.815 0)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49908",
    "data-name": "Path 49908",
    d: "M156.277,383.6a4.2,4.2,0,0,0-3.236-3.178,4.136,4.136,0,0,0-.828-.083h0a4.151,4.151,0,0,0-3.252,1.577,4.209,4.209,0,0,0-.918,2.63v.636h8.34v-.636A4.237,4.237,0,0,0,156.277,383.6Z",
    transform: "translate(-142.528 -364.554)",
    fill: "#d4d4d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49909",
    "data-name": "Path 49909",
    d: "M151.873,386.774a11.325,11.325,0,0,1-.486-3.284v-1.124a4.169,4.169,0,0,0-2.425,1.492,4.224,4.224,0,0,0-.918,2.63v.636h3.935Z",
    transform: "translate(-142.529 -366.494)",
    fill: "#b9bbbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49910",
    "data-name": "Path 49910",
    d: "M148.961,394.331a4.209,4.209,0,0,0-.918,2.63v.636h2.67a12.543,12.543,0,0,1-.538-3.634v-.67A4.211,4.211,0,0,0,148.961,394.331Z",
    transform: "translate(-142.528 -376.967)",
    fill: "#ce857a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49911",
    "data-name": "Path 49911",
    d: "M165.511,393.962v-.67a4.211,4.211,0,0,0-1.214,1.039q-.076.1-.146.195a.6.6,0,0,0,.039.738l.632.742-.172.449a.609.609,0,0,0,.374.795l1.026.346A12.546,12.546,0,0,1,165.511,393.962Zm5.29.368a4.209,4.209,0,0,1,.918,2.63v.636h-2.67a12.543,12.543,0,0,0,.538-3.634v-.67A4.211,4.211,0,0,1,170.8,394.331Z",
    transform: "translate(-157.864 -376.967)",
    fill: "#d6948c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49912",
    "data-name": "Path 49912",
    d: "M285.17,393.962v-.67a4.212,4.212,0,0,1,1.36,1.233.6.6,0,0,1-.038.739l-.632.742.172.45a.609.609,0,0,1-.374.795l-1.026.346A12.546,12.546,0,0,0,285.17,393.962Z",
    transform: "translate(-273.447 -376.967)",
    fill: "#e8b5b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49913",
    "data-name": "Path 49913",
    d: "M203.48,364.716l-2.038-1.237-2.038,1.237s0,.473,0,.651a.439.439,0,0,0,.019.133,5.439,5.439,0,0,0,4.037,0,.439.439,0,0,0,.019-.133c0-.178,0-.647,0-.651Z",
    transform: "translate(-191.757 -348.391)",
    fill: "#efedee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49914",
    "data-name": "Path 49914",
    d: "M32.669,166.466h-15.6a1.883,1.883,0,0,0,0,3.766h15.6a1.883,1.883,0,0,0,0-3.766Z",
    transform: "translate(-15.182 -159.556)",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49915",
    "data-name": "Path 49915",
    d: "M69.65,23.991a7.8,7.8,0,1,0,6.5,7.693A7.852,7.852,0,0,0,69.65,23.991Z",
    transform: "translate(-58.666 -22.892)",
    fill: "#ffddcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49916",
    "data-name": "Path 49916",
    d: "M63.137,31.7a7.812,7.812,0,0,1,6.513-7.7,7.8,7.8,0,1,0,0,15.387A7.79,7.79,0,0,1,63.137,31.7Z",
    transform: "translate(-58.666 -22.892)",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28912",
    "data-name": "Group 28912",
    transform: "translate(3.874 10.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49917",
    "data-name": "Path 49917",
    d: "M110.07,243.755a1.271,1.271,0,1,0,1.56,1.238A1.427,1.427,0,0,0,110.07,243.755Zm8.5,0a1.271,1.271,0,1,0,1.56,1.238A1.427,1.427,0,0,0,118.571,243.755Z",
    transform: "translate(-108.51 -243.755)",
    fill: "#ff8e9e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28913",
    "data-name": "Group 28913",
    transform: "translate(6.014 9.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49918",
    "data-name": "Path 49918",
    d: "M160.365,221.833a.311.311,0,0,0-.311.311v.646a.311.311,0,0,0,.623,0v-.646a.311.311,0,0,0-.311-.311Zm6.72,0a.311.311,0,0,0-.311.311v.646a.311.311,0,1,0,.623,0v-.646A.311.311,0,0,0,167.085,221.833Zm-2.27.7a.311.311,0,0,0-.439.03.863.863,0,0,1-1.3,0,.311.311,0,1,0-.469.409,1.485,1.485,0,0,0,2.241,0A.311.311,0,0,0,164.816,222.536Z",
    transform: "translate(-160.054 -221.833)",
    fill: "#313d40"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49919",
    "data-name": "Path 49919",
    d: "M72.563,20.4a8.207,8.207,0,0,0-15.928,0l.392.1A7.817,7.817,0,0,0,56.8,22.38a9.343,9.343,0,0,0,7.8-4.213,9.343,9.343,0,0,0,7.8,4.213,7.816,7.816,0,0,0-.229-1.883Z",
    transform: "translate(-54.914 -13.587)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49920",
    "data-name": "Path 49920",
    d: "M63.233,14.287a8.191,8.191,0,0,0-6.6,6.111l.392.1a7.817,7.817,0,0,0-.229,1.883,9.315,9.315,0,0,0,3.727-.778A15.057,15.057,0,0,1,64.6,14.174,8.264,8.264,0,0,0,63.233,14.287Z",
    transform: "translate(-54.914 -13.586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlHighlighted);
export default __webpack_public_path__ + "static/media/GirlHighlighted.84a1d95392eb6c84ba54dc89cfbfd85d.svg";
export { ForwardRef as ReactComponent };